import React, {useEffect, useState} from "react";
import axios from 'axios';
import {setError} from "../../slices/error/ErrorSlice";
import {useDispatch} from "react-redux";
import withAccess from "../hoc/withAccess";
import {setDined} from "../../slices/error/AccessSlice";
const History = () => {
    const dispatch = useDispatch();

    const [history, setHistory] = useState([]);
    const [searchParams, setSearchParams] = useState({
        date_from: '',
        date_to: '',
        postavka_num: '',
        numfito: ''
    });

    useEffect(() => {
        getHistory();
    }, []);

    function changeSearchParamsHandler(e) {
        let name = e.target.name;
        setSearchParams({...searchParams, [name]: e.target.value});
    }

    function getHistory() {
        axios.get('/api/history-list', {params: searchParams})
            .then(res => {
                setHistory(res.data);

                let newSearchParams = {...searchParams};

                newSearchParams.date_from = res.headers['x-pagination-date-from'];
                newSearchParams.date_to = res.headers['x-pagination-date-to'];
                setSearchParams(newSearchParams);
            })
            .catch(e => {
                if (e.status === 403) {
                    dispatch(setDined(true));
                } else dispatch(setError(e.response.data));
            })
    }

    function searchHandler() {
        getHistory();
    }

    let rows = history.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.postavka_num}</td>
            <td>{item.fss}</td>
            <td>{item.user}</td>
            <td>{item.updated_at}</td>
        </tr>
    )

    return (
        <>
            <h1>История изменений</h1>

            <div className='card bg-light shadow-sm p-2 pt-3 m-2'>
                <div className='row d-inline-flex mt-1'>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_from">С</label>
                        <input className="form-control min-width-150" type="date" id="date_from"
                               name="date_from" value={searchParams.date_from} onChange={changeSearchParamsHandler}
                        />
                    </div>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="date_to">По</label>
                        <input className="form-control min-width-150" type="date" id="date_to" name="date_to"
                               value={searchParams.date_to} onChange={changeSearchParamsHandler}
                        />
                    </div>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="postavka_num">№ поставки</label>
                        <input className="form-control min-width-150" type="text" id="postavka_num" name="postavka_num"
                               value={searchParams.postavka_num} onChange={changeSearchParamsHandler}
                        />
                    </div>
                    <div className="col-auto textOnInput align-top">
                        <label htmlFor="numfito">№ фито</label>
                        <input className="form-control min-width-150" type="text" id="numfito" name="numfito"
                               value={searchParams.numfito} onChange={changeSearchParamsHandler}
                        />
                    </div>
                    <div className='col-auto text-center'>
                        <input type='button' className='btn mb-0 btn-success' value='Поиск' onClick={searchHandler}
                        />
                    </div>
                </div>
            </div>

            <div className='m-2'>
                <table className="table table-bordered">
                    <thead>
                    <tr className='table-th'>
                        <th>id</th>
                        <th>Поставка №</th>
                        <th>Номер фито</th>
                        <th>Пользователь</th>
                        <th>Дата/Время</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows}
                    </tbody>
                </table>
            </div>
        </>

    )
}

const HistoryWithAccess = withAccess(History);
export default HistoryWithAccess;